module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_admin_organize", [["div",{"class":"organize-wrapper"},[["div",{"class":"fixed-header"},[["section",{"class":"title-wrapper"}],["div",{"class":"preview-area-wrapper"}],["div",{"class":"page-width filter-wrapper"}]]],["div",{"class":"page-width content-container"},[["section",{"class":"mc-content-grid mc-organize-grid","id":"mc-organize-grid"}],["div",{"class":"pager-wrapper"},[["div",{"id":"content-pager","class":"mc-pagination flex-wide"}]]]]]]]]);
fox.registerTemplate("layout_admin_organize_content_container", [["div",{"id":"preview-content-container"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/admin/organize.tpl
// module id = 241
// module chunks = 2